import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import ModalContext from "contexts/ModalContext";
import helper from "services/helper";
import PageHeader from "components/PageHeader";
import { SearchCustomer } from "services/Api/Module/Customer";
import BottomAction from "components/BottomAction";
const CollectPointTel = () => {
  const navigate = useNavigate();
  const { mAlert } = useContext(ModalContext);

  const [ contactNumber, setContactNumber ] = useState("")
  // SearchCustomer
  const fetchSearchCustomer = async (payload) => {
    try {
      const response = await SearchCustomer({ params: payload })
      const resData = response.data
      if (resData.resultCode === 20000) {
        navigate(`/collect-point-confirm?contactNumber=${contactNumber}`)
      } else {
        mAlert.info({
          title: "ไม่พบเบอร์มือถือ",
          subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
          content: "",
          onClose: () => {},
        })
      }
    }
    catch (err) {
      console.log('AAA err ', err)
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => {},
      })
    }
  }




  const onNext = () => {
    // alert("onNext!")
    const payload = {
      contactNumber: contactNumber
    }
    console.log("🚀 ~ onNext ~ payload:", payload)
    fetchSearchCustomer(payload)
    
  }
  useEffect(() => {}, []);

  return (
    <div>
      <Helmet>
        <title></title>
        <meta name="title" content="" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>
      <div id="pageVerified">

        {/* <!-- Page Header --> */}
        <PageHeader title="สะสมคะแนนผ่านเบอร์" onBack={() => navigate("/profile")}/>

        {/* <!-- Content Page --> */}
        <main id="top">
          <div className="wrapContent">
            <section id="pRegister">
              <div className="bRegisterMain">
                <form >
                  <div className="bForm">
                    <h2>สะสมคะแนนผ่านเบอร์</h2>
                    <div className="bGroup">
                      <div className="bRow">
                        <div className="control-group">
                          <div className="inputPlaceholder">
                            <span>080-000-0000</span>
                            <input 
                              type="text"
                              inputmode="numeric" 
                              value={contactNumber} 
                              onInput={helper.FNFORM.handleNumberOnly}
                              onChange={(e) => setContactNumber(e.target.value)} 
                              maxLength={10}
                              name="" 
                              placeholder="080-000-0000"
                            />
                          </div>
                          <label for="" className="tError">กรุณากรอกเบอร์โทรศัพท์</label>
                        </div>
                      </div>
                    </div>
                  </div>                
                </form>
              </div>
            </section>

            <BottomAction type="next" onNext={onNext} />
          </div>
        </main>

      </div>
     
    </div>
  );
};

export default CollectPointTel;
